import { apiRequest } from "@core/services/api/apiRequest";
import type { UploadInfo, UploadMetadata } from "./completeDirectUpload";

export async function generatePresignedUrl(
  file: File,
  metadata: UploadMetadata = {}
): Promise<UploadInfo> {
  const payload = {
    file_name: file.name,
    file_type: file.type,
    file_size: file.size,
    upload_type: metadata.file_type || "document",
    organization_id: metadata.organization_id,
  };

  const response = await apiRequest(
    "/uploads/presigned-url/",
    "POST",
    payload,
    true
  );
  return response;
}

